import { useQueryClient } from '@tanstack/react-query';
import type { ScheduleModel } from 'entities/campaign';
import { useGetCampaigns, campaignsKey, campaignRoutes, useGetCampaignsUrlFilters } from 'entities/campaign';
import { usePutMutation, getApiType, useGetQuery } from 'shared/lib/api';
import { logError } from 'shared/lib/log-errors';
import { pathToUrl } from 'shared/lib/router';
import type { Timezone } from 'shared/lib/timezones';

export function useUpdateCallCenterSchedule(id: number) {
  const queryClient = useQueryClient();
  const urlFilters = useGetCampaignsUrlFilters();
  const getCampaignsQuery = useGetCampaigns({ enabled: false, urlFilters });

  return usePutMutation<{ schedule: ScheduleModel | null }>(
    pathToUrl(campaignRoutes[getApiType()].updateCampaign, { id }),
    {
      onSuccess: () => {
        getCampaignsQuery.refetch().catch(logError);
        queryClient.invalidateQueries(campaignsKey.campaign(id).queryKey).catch(logError);
      },
    }
  );
}

export function useGetCallCenterRestrictionTimeRange(timezone: Timezone) {
  return useGetQuery<ScheduleModel>(campaignRoutes.internal.getCallCenterRestrictionTimeRange, {
    queryParams: {
      timezone,
    },
  });
}
